import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import ModalDommus from '../../../../components/Modal';
import { infoToast } from '../../../../components/DommusToast';

export default function ModalOtp({ open, onClose, onConfirmar }) {
  const [codigo, setCodigo] = useState('');

  function handleChangeCodigo(e) {
    const valor = e.target.value.replace(/\D/g, '').slice(0, 6);
    setCodigo(valor);
  }

  function handleConfirmar() {
    onConfirmar(codigo);
    setCodigo('');
  }

  function handleFechar() {
    setCodigo('');
    onClose();
    infoToast.fire({ text: 'Registro cancelado.' });
  }

  return (
    <ModalDommus open={open} close={handleFechar} titulo="Verificação OTP" size="md">
      <Form.Group>
        <Form.Label>
          Digite o código de 6 dígitos recebido via SMS ou chamada de voz
        </Form.Label>
        <Form.Control
          type="text"
          value={codigo}
          onChange={handleChangeCodigo}
          maxLength={6}
          placeholder="000000"
          inputMode="numeric"
          pattern="[0-9]*"
        />
      </Form.Group>
      <Button
        variant="primary"
        onClick={handleConfirmar}
        disabled={codigo.length !== 6}
        className="mt-3"
      >
        Confirmar
      </Button>
    </ModalDommus>
  );
}
